import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import Language from './Language';
import AiTranslation from './AiTranslation';

const reducers = combineReducers({
  theme: Theme,
  auth: Auth,
  language: Language,
  aiTranslation: AiTranslation,
});

export default reducers;
